import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "has-first-letter-uppercase has-text-success is-size-5" }
const _hoisted_2 = { class: "my-3" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { ref: "modal" }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('station_list.export.title', {station: _ctx.station.name})), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      (_ctx.failure)
        ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            title: _ctx.$t('global.failure'),
            type: "error",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.try_again')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('station_list.export.date_range')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_n_date_picker, {
              value: _ctx.dateRange,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
              type: "datetimerange"
            }, null, 8 /* PROPS */, ["value"])
          ]),
          _withDirectives(_createElementVNode("p", { class: "help is-danger" }, _toDisplayString(_ctx.$t('global.field_required')), 513 /* TEXT, NEED_PATCH */), [
            [_vShow, !_ctx.dateRange && !_ctx.valid]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('station_list.export.filetype')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["select is-fullwidth", {'is-danger': !_ctx.selectedFileType && !_ctx.valid}])
            }, [
              _withDirectives(_createElementVNode("select", {
                required: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFileType) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileTypes, (fileType) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: fileType,
                    value: fileType
                  }, _toDisplayString(fileType), 9 /* TEXT, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.selectedFileType]
              ])
            ], 2 /* CLASS */)
          ]),
          _withDirectives(_createElementVNode("p", { class: "help is-danger" }, _toDisplayString(_ctx.$t('global.field_required')), 513 /* TEXT, NEED_PATCH */), [
            [_vShow, !_ctx.selectedFileType && !_ctx.valid]
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "button is-light mr-2",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _toDisplayString(_ctx.$t('global.cancel')), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "button is-success",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, _toDisplayString(_ctx.$t('station_list.export.download')), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}